export const environment = {
  production: false,
  base_url: 'https://dev.autooptiq.com'
};
